(ns manage.advertiser-page.view
  (:require ["@mui/material/Chip$default" :as Chip]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :refer [advertiser-query]]
            [common.util :refer [spread-obj]]
            [common.widgets.advertiser-menu :refer [advertiser-menu]]
            [common.widgets.page :as page]
            [manage.campaign.list-view :as list-view]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui advertiser-page
  [_]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{:keys [archived name isDemo]} :data} (use-query (spread-obj (advertiser-query {:advertiser-id advertiser-id})
                                                                      #js {:throwOnError true}))]
    ($ page/page
       ($ page/page-header
          {:title name
           :buttons ($ advertiser-menu {:archived archived})}
          (when archived
            ($ Chip {:label "Archived"}))
          (when isDemo
            ($ Chip {:label "Demo Account"})))
       ($ page/content-padding
          {:sx #js {:overflow "hidden"}}
          ($ list-view/list-view-contents)))))
